import * as Yup from 'yup';
import { CROATIA_COUNTRY_ID, messages } from 'app/config/constants';

export const defaultAddressValidation = Yup.object({
  country: Yup.array().of(Yup.object()).min(1, messages.MANDATORY_FIELD),
  communityString: Yup.object().when('country', (country, schema) => {
    if (country && country[0] && country[0][0] && country[0][0].id === CROATIA_COUNTRY_ID) {
      return Yup.string().notRequired();
    }
    return Yup.string().required(messages.MANDATORY_FIELD);
  }),
  community: Yup.array().when('country', (country, schema) => {
    if (country && country[0] && country[0][0] && country[0][0].id === CROATIA_COUNTRY_ID) {
      return Yup.array().of(Yup.object()).min(1, messages.MANDATORY_FIELD);
    }
    return Yup.array().notRequired();
  }),
  streetString: Yup.object().when('country', (country, schema) => {
    if (country && country[0] && country[0][0] && country[0][0].id === CROATIA_COUNTRY_ID) {
      return Yup.string().notRequired();
    }
    return Yup.string().required(messages.MANDATORY_FIELD);
  }),
  street: Yup.array().when('country', (country, schema) => {
    if (country && country[0] && country[0][0] && country[0][0].id === CROATIA_COUNTRY_ID) {
      return Yup.array().of(Yup.object()).min(1, messages.MANDATORY_FIELD);
    }
    return Yup.array().notRequired();
  }),
  postalCode: Yup.string().required(messages.MANDATORY_FIELD),
  postName: Yup.string().required(messages.MANDATORY_FIELD),
  houseNumberString: Yup.object().when('country', (country, schema) => {
    if (country && country[0] && country[0][0] && country[0][0].id === CROATIA_COUNTRY_ID) {
      return Yup.string().notRequired();
    }
    return Yup.string().required(messages.MANDATORY_FIELD);
  }),
  houseNumber: Yup.array().when('country', (country, schema) => {
    if (country && country[0] && country[0][0] && country[0][0].id === CROATIA_COUNTRY_ID) {
      return Yup.array().of(Yup.object()).min(1, messages.MANDATORY_FIELD);
    }
    return Yup.array().notRequired();
  }),
});
